export default __webpack_public_path__ + "a3946c6abbf5644e1ef80cd02491f8e6.png";